import React, { useState } from "react";
import { Link } from "react-router-dom";
import { RiMailAddLine, RiCloseLine } from "react-icons/ri";

const DISMISS_KEY = "twb_songflow_banner_dismissed";

/**
 * A dismissible banner encouraging users to sign up for free
 * curated song-flow emails. Always visible until dismissed.
 */
export default function CuratedSongFlowSignupBanner() {
    const [dismissed, setDismissed] = useState(
        sessionStorage.getItem(DISMISS_KEY) === "true"
    );

    if (dismissed) return null;

    const handleDismiss = () => {
        sessionStorage.setItem(DISMISS_KEY, "true");
        setDismissed(true);
    };

    return (
        <div
            style={{
                margin: "0 0 2rem 0",
                padding: "16px 20px",
                borderRadius: "8px",
                background: "#f0f2ff",
                borderLeft: "5px solid #5e72e4",
                display: "flex",
                alignItems: "center",
                gap: "16px",
                position: "relative",
            }}
        >
            {/* Icon */}
            <div
                style={{
                    flexShrink: 0,
                    width: 44,
                    height: 44,
                    borderRadius: "50%",
                    background: "#5e72e4",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <RiMailAddLine size={22} color="#ffffff" />
            </div>

            {/* Text */}
            <div style={{ flex: 1, minWidth: 0 }}>
                <div
                    style={{
                        fontFamily: "Arial, sans-serif",
                        fontWeight: 700,
                        fontSize: "0.95rem",
                        color: "#172b4d",
                        marginBottom: "2px",
                    }}
                >
                    Get free curated worship song-flows in your inbox
                </div>
                <div
                    style={{
                        fontFamily: "Arial, sans-serif",
                        fontSize: "0.85rem",
                        color: "#525f7f",
                    }}
                >
                    No account needed. Receive hand-picked song-flows to help you plan your services.
                </div>
            </div>

            {/* CTA */}
            <Link
                to="/song-flows/subscribe"
                style={{
                    flexShrink: 0,
                    display: "inline-block",
                    background: "#5e72e4",
                    color: "#ffffff",
                    fontFamily: "Arial, sans-serif",
                    fontWeight: 600,
                    fontSize: "0.875rem",
                    textDecoration: "none",
                    padding: "9px 18px",
                    borderRadius: "6px",
                    whiteSpace: "nowrap",
                }}
            >
                Sign up free
            </Link>

            {/* Dismiss */}
            <button
                onClick={handleDismiss}
                aria-label="Dismiss"
                style={{
                    flexShrink: 0,
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "4px",
                    color: "#8898aa",
                    lineHeight: 1,
                }}
            >
                <RiCloseLine size={20} />
            </button>
        </div>
    );
}
